import type { FC } from "react";
import { NineamComponents } from "src/lib/HtmlParser";
import translate from "src/lib/translate";
import type { TranslationKey } from "src/types/translationKey";
import VimeoService from "src/api/VimeoService";
import SanityService from "src/api/SanityService";
import MediaPlayer from "src/ui/components/MediaPlayer/MediaPlayer";
import Feedback from "src/ui/components/Feedback/Feedback";
import CSATFeedback from "src/ui/components/CSATFeedback/CSATFeedback";

type ComponentRenderer = FC<{ attrs: Record<string, unknown> }>;

const VideoEmbed: ComponentRenderer = ({ attrs }) => {
  const src = String(attrs.src ?? "");
  const version = String(attrs.version ?? "default");
  const vimeoId = VimeoService.extractIdFromUrl(src);
  const sanityId = SanityService.checkIsVideoId(src);

  if (vimeoId) {
    return (
      <MediaPlayer
        videoId={vimeoId}
        videoProvider="vimeo"
        title=""
        playIcon="simple"
        inline={version === "inline"}
      />
    );
  }

  if (sanityId) {
    return (
      <MediaPlayer
        videoId={sanityId}
        videoProvider="sanity"
        title=""
        playIcon="simple"
        inline={version === "inline"}
      />
    );
  }

  return <div>{translate("leapChat.videoNotFound" as TranslationKey)}</div>;
};

export const nineamComponentRegistry: Record<string, ComponentRenderer> = {
  [NineamComponents.video]: VideoEmbed,
  [NineamComponents.feedback]: () => <Feedback />,
  [NineamComponents.csatFeedback]: () => <CSATFeedback />
};
